export default __webpack_public_path__ + "static/monitors-121347234ab8e3542b0af87446ed376a.png";